import type { BaseTranslation } from "../i18n-types"

const en: BaseTranslation = {
  generic: {
    addToCartText: "ADD TO BAG",
    addedToBag: "ADDED TO BAG",
    addingToCartText: "ADDING TO BAG ...",
    reserveInStoreText: "RESERVE IN STORE",
    reserveInStoresubHeadingText:
      "We will connect with you to arrange an appointment or to help coordinate your purchase.",
    closeText: "CLOSE",
    emailCustomerCareLabel: "Email customer care",
    customerCareHelpText:
      "Please call 1-888-DYURMAN (1-888-398-7626) or complete the form below for complimentary help with your purchase or for gift suggestions.",
    customerCareSuccessText:
      "Your email has been received. A Customer Care specialist will be in touch shortly.",
    customerServiceLabel: "CUSTOMER SERVICE",
    customerServiceText:
      "IF YOU HAVE  ANY QUESTIONS OR NEED FURTHER ASSISTANCE,PLEASE CONTACT US, PROVIDE ID# FOR EXPEDITED SERVICE",
    customerServiceNoLabel: "1-888-DYURMAN (398-7626)",
    customerServiceNo: "1-888-398-7626",
    emailUsText: "Send us an email",
    emailCustomerCareText: "Email customer service",
    emailClientLinkText: "customercare@davidyurman.com",
    termsAndConditionsText: "Terms and Conditions",
    contactUsText: "Contact Us",
    contactCustomerCareText: "Contact Customer Care",
    backToShippingBag: "Back to Shopping Bag",
    customerCareText: "Customer Care",
    customerCareNumber: "1-888-DYURMAN",
    registerLoginText: "Sign In",
    loginText: "Login",
    accountText: "Account",
    hiText: "Hi",
    cancelBtnText: "Cancel",
    undoBtnText: "undo",
    confirmBtnText: "Confirm",
    backgroundImage:
      "https://img.davidyurman.com/is/image/DavidYurman/AccountPlaceholderHero?$hero$",
    removeText: "Remove",
    systemErr:
      "A system error has occurred, we apologize for any inconvenience. Please contact Customer Care at 888-DYURMAN (888-398-7626) for further assistance.",
    appHeaderName: "david yurman",
    availabilitytext: "Availability",
    inStocktext: "In Stock",
    outOfStockText: "Out Of Stock",
    priceDisclaimer: "Prices include taxes, duties and shipping.",
    errorOccurredText: "Error Occurred",
    editText: "Edit",
    epsSizeNotAvailableText: "Not Available",
    styleNumberLabel: "Style Number",
    colorLabel: "COLOR",
    removingText: "Removing",
    charLeftText: "characters left",
    saveText: "Save",
    cancelText: "Cancel",
    nameText: "Name",
    selectDropDownLabel: "Select",
    productDetailsLabel: "Product Details",
    printLabel: "Print",
    loadingText: "Loading",
    backToTopLabel: "Back to Top",
    allInformationRequired: "All information required",
    toHomepage: "return to homepage",
  },
  bracelets: {
    addMore: "Add More",
    copyClipboard: "Copied to clipboard",
    copyCTA: "Copy This Link",
    copyDescription:
      "Copy the link below to share your curated assortment with friends and family.",
    done: "Done",
    introHeadline: "Select Your Bracelets",
    introDescription:
      "Choose your favorite styles, metals and gemstones for layering. Once you’ve made your selection, tap or click a design to move it higher or lower in your stack. If you’d like to remove a bracelet, tap or click the X next to it.",
    help: "Need Help?",
    limitHeadline: "Limit Reached",
    limitDescription:
      "You cannot add any more bracelets. Please remove a bracelet to add this design",
    modify: "Modify",
    moreInfo: "Click for More Info",
    moreDetails: "View Full Details",
    nextStep: "Next Step",
    quickView: "Quick View",
    rearrange: "Rearrange",
    previewSelection: "Preview Your Selection",
    reviewSelection: "Review Your Selection",
    reviewStack: "Review Your Stack",
    selected: "Selected",
    share: "Share",
    shareThis: "Share This",
    viewDetails: "View Details",
  },
  amulets: {
    amuletGridHeadline: "ADD AMULETS ({0} OF {1}) ",
    changeChain: "Change Chain",
    chooseHeadline: "Choose Your Chain",
    chooseChain: "Choose your chain",
    copyClipboard: "Copied to clipboard",
    copyCTA: "Copy This Link",
    copyDescription:
      "Copy the link below to share your curated assortment with friends and family.",
    done: "Done",
    expand: "Expand",
    introHeadline: "Add Amulets",
    introDescription:
      "Drag and drop your favorite designs to see them on your chain.",
    help: "Need Help?",
    limit: "Limit Reached",
    limitDescription:
      "You cannot add any more amulets. Please remove an amulet to add this design.",
    moreInfo: "Click for More Info",
    moreDetails: "View Full Details",
    nextStep: "Next Step",
    modify: "Modify",
    previewNecklace: "Preview Necklace",
    rearrange: "Rearrange",
    reviewSelection: "Review Your Selection",
    selected: "Selected",
    share: "Share",
    shareThis: "Share This",
  },
  search: {
    noResultFoundHeadingText: "No results were found for",
    noResultFoundSubHeadingText:
      "Please try a different search, or explore our suggestions below.",
    applyFiltersText: "Apply",
    clearFiltersText: "Clear Filters",
    sortText: "Sort by",
    filterText: "FILTER",
    seeAllCollectionsText: "See All Collections",
    searchSuggestionsText: "Search Suggestions",
    productSuggestionsText: "Product Suggestions",
  },
  productConfig: {
    metalLabel: "Metal",
    motifLabel: "Design Motif",
    monogramLabel: "Monogram",
    sizeLabel: "SIZE",
    designLabel: "Design",
    initialsLabel: "Initials",
    engraveThisRingText: "Engrave This Ring",
    engraveYourRingText: "Engrave Your Ring",
    engraveThisNecklaceText: "Engrave This Necklace",
    engraveYourNecklaceText: "Engrave Your Necklace",
    selectMetalText: "Select a Metal",
    selectDesignText: "Select a Monogram",
    selectDesign2Text: "or a Design Motif",
    selectDesignDropdownText: "Select Design",
    selectMotifText: "Select a Design Motif",
    selectMonogramText: "Select a Monogram",
    backText: "Back",
    nextText: "Next",
    enterInitialsText: "STEP 2: ENTER INITIALS",
    enter3InitialsText: "Enter up to 3 initials",
    fontLabel: "STEP 1: CHOOSE A STYLE",
    reviewHeaderText: "Review Your Selections",
    reviewPt1HeaderText: "Review",
    reviewPt2HeaderText: "Your Selections",
    step3MonogramText:
      "Traditionally, a monogram features the initial for the last name in the middle, but you can make your mark any way you like.",
    pinkyPDPText:
      "Personalize your design with a custom-engraved monogram or motif.",
  },
  form: {
    submitText: "SUBMIT",
    requiredErrorText: "This field is required",
    emptySearchText: "Please enter search term",
    maxLengthError: "The maximum characters allowed is {0}",
    minLengthError: "The minimum characters allowed is {0}",
    emailAddressRequiredText: "Please enter an email address",
    invalidEmailErrText: "Invalid email address",
    firstNameRequiredErrText: "Please enter a first name",
    lastNameRequiredErrText: "Please enter a last name",
    invalidNameErrText: "Please enter a valid name",
    streetAddressLabel: "Street Address",
    streetAddressRequiredErr: "Please enter Street Address",
    apartmentAddressLabel: "Apartment/Suite #",
    apartmentAddressRequiredErrText: "Please enter Apartment/Suite #",
    cityLabel: "City",
    cityRequiredErrText: "Please enter City",
    zipCodeLabel: "Zip Code",
    zipCodeRequiredErrText: "Please enter Zip Code",
    zipCodeValidErrText: "Please enter Valid Zip Code",
    postalCodeText: "Postal Code",
    postalCodeRequiredErrText: "Please enter Postal Code",
    postalCodeValidErrText: "Please enter Valid Postal Code",
    stateLabel: "State",
    stateRequiredErrText: "Please select State",
    provinceLabel: "Province",
    provinceRequiredErrText: "Please select Province",
    countryLabel: "Country",
    countryRequiredErrText: "Please select Country",
    inquiryRequiredText: "Please select Inquiry Type",
    phoneNumberLabel: "Phone #",
    phoneNumberRequiredErrText: "Please enter a Phone Number",
    firstNameLabel: "First Name",
    lastNameLabel: "Last Name",
    emailLabel: "Email Address",
    retypeEmailLabel: "Retype Email Address*",
    passwordLabel: "Password*",
    retypePasswordLabel: "Retype Password*",
    passwordRequiredText: "Please enter a password",
    invalidPasswordErrText:
      "Please create a password that meets password requirements detailed below and try again.",
    forgotPasswordText: "Forgot Your Password?",
    loginButtonText: "Log In",
    applybtnText: "Apply",
    genderLabel: "Gender",
    dateOfBirthLabel: "Birthday(MM/DD/YYYY)",
    anniversaryLabel: "Anniversary/Wedding Date (MM/DD/YYYY)",
    resetPasswordText: "Reset Password",
    currentEmailLabel: "Current Email*",
    newEmailLabel: "New Email*",
    confirmEmailLabel: "Confirm Email*",
    updateBtnText: "UPDATE",
    UnsubscribeBtnText: "Unsubscribe",
    anniversaryErrText:
      "Anniversary cannot be lesser than or equal to date of birth",
    invalidAnniversaryErrText: "Please enter a valid anniversary date",
    emailAddressLabel: "Email Address",
    orderNumberText: "Please enter an order number",
  },
  pdp: {
    sizeSelectionErrorText: "Please Select Size",
    braceletSize: "{0}'s Bracelet Size Chart",
    seeSizeChartLabel: "See Size Chart",
    initialLabel: "Initial",
    amountLabel: "Amount",
    rollOverToZoomText: "Roll over to zoom",
    sizeChartText: "Size Chart",
    viewDetailsText: "View Details",
    checkGiftCardBalanceText: "Check David Yurman Gift Card Balance",
    buyEGiftCardText: "Buy An e-Gift Card",
    shareText: "Share",
    gemStoneLabel: "GEMSTONE",
    sharetoFacebook: "share product to facebook",
    sharetoTwitter: "share product to twitter",
    sharetoPinterest: "share product to pinterest",
    pricedFrom6550: "Priced From $6,550*",
    fitAndCareText: "Care",
    pdpImageText: "Product Image",
    contactProductSpecialistText: "CONTACT A PRODUCT SPECIALIST",
    productSpecialistHeading: "Product Specialist",
    weddingBridalText: "Wedding/Bridal",
    notSellOptOutText: "Do Not Sell Opt-Out",
    careText: "",
    gcBrailleCheckboxText: "Click here to receive a braille gift card.",
    notifyDescText:
      "This item is currently not available. Please enter your email address to be notified when this product is available.",
    notifyMeText: "Notify me",
    weWillBeInTouchText: "We will be in touch",
    notifyHeaderCopy: "Notify Me When Available",
    notifyBodyCopy:
      "Please enter your name, phone number, and email address, and we'll connect with you when this design is back in stock",
    notifyConfirmationHeaderCopy: "You're On The List",
    notifyConfirmationBodyCopy:
      "Thank you for your interest in this desgin. We'll reach out to you when it becomes available",
    notifyConfirmationBodyCopyShort:
      " We'll reach out to you when this design becomes available",
    preOrderLabel: "PREORDER",
    preOrderCopyOrderConfirmation:
      "Estimated ship date: $PREORDERDATE. Payment is authorized when your order is confirmed and charged at the time of shipment.",
    preOrderCopy:
      "This design is available for pre-order. Estimated ship date: $PREORDERDATE. Payment is authorized when your order is confirmed and charged at the time of shipment.",
  },
  stackItWith: {
    title: "Stack Title",
    description: "Stack Description",
    customize: "CUSTOMIZE",
    stackCTA: "SHOP THE STACK",
    engagementStackCTA: "ADD BAND TO BAG",
    engagementPerfectBandsTitle: "Perfect Bands",
    engagementPerfectBandsDescription: "Perfect Bands Description",
  },
}

export default en
